<div class="offcanvas-header d-flex justify-content-end align-items-center">
  <app-help-tour-button (tourClick)="iniciarTour()"></app-help-tour-button>
</div>
<div class="offcanvas-body overflow-auto">
  <form [formGroup]="novaMensagemForm" (ngSubmit)="onSubmit($event)">
    <!-- Informações do Cliente -->
    <div class="card mb-3" id="tour-modal-informacoes-cliente">
      <div class="card-header informacoes-cliente-header d-flex justify-content-between align-items-center" (click)="toggleInformacoesCliente()">
        <h6 class="card-title mb-0">Informações do Cliente</h6>
        <i class="fas" [ngClass]="informacoesClienteExpandido ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </div>
      <div class="card-body informacoes-cliente-body" [class.collapsed]="!informacoesClienteExpandido">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nome do Cliente</label>
            <p class="form-control-plaintext">{{ clientRequest?.nomeCliente || '-' }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">CNPJ</label>
            <p class="form-control-plaintext">{{ clientRequest?.cnpjCliente || '-' }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Contato</label>
            <p class="form-control-plaintext">{{ clientRequest?.contatoCliente || '-' }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Email</label>
            <p class="form-control-plaintext">{{ clientRequest?.emailCliente || '-' }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Telefone</label>
            <p class="form-control-plaintext">{{ clientRequest?.telefoneCliente || '-' }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Celular</label>
            <p class="form-control-plaintext">{{ clientRequest?.celularCliente || '-' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3" id="tour-modal-status">
      <label for="status" class="form-label">Status</label>
      <select formControlName="statusId" class="form-select" name="statusId">
        <option value="">Selecione um status</option>
        <option *ngFor="let status of statusMessages" [value]="status.id">
          {{ status.nome | statusCorFormatter:'nome' }}
        </option>
      </select>
    </div>

    <div class="mb-3" id="tour-modal-agendamento">
      <label for="scheduledDate" class="form-label">Agendamento</label>
      <input formControlName="dataAgendamento" type="date" class="form-control" name="dataAgendamento" />
    </div>

    <div class="mb-3" id="tour-modal-mensagens">
      <label for="mensagens" class="form-label">Mensagens</label>
      <div id="mensagens" class="mensagens-container">
        @for (mensagem of clientRequest?.mensagens; track mensagem?.mensagemId) {
        <div class="mensagem-item">
          <p class="mensagem-text">{{ mensagem?.mensagem }}</p>
          <small class="mensagem-data">
            {{ mensagem?.dataCadastro | date: "short" }}
          </small>
        </div>
        }
        @if (clientRequest?.mensagens?.length === 0) {
        <p class="text-muted">Nenhuma mensagem cadastrada</p>
        }
      </div>
    </div>

    <div class="mb-3" id="tour-modal-mensagem-personalizada">
      <label for="mensagemPersonalizada" class="form-label">
        Mensagens personalizadas
      </label>
      <select class="form-select" id="mensagemPersonalizada" formControlName="mensagemPersonalizada"
        (change)="onMensagemSelecionada($event)">
        <option value="">Selecione uma mensagem</option>
        @for (customMessage of customMessages; track customMessage.id) {
        <option value="{{customMessage.id}}">
          {{ customMessage.titulo }}
        </option>
        }
      </select>
    </div>
    <div class="mb-3" id="tour-modal-nova-mensagem">
      <label for="message" class="form-label">Nova Mensagem</label>
      <textarea formControlName="mensagem" class="form-control" rows="3"
        [value]="selectedCustomMessage?.mensagem || ''"></textarea>

      <div *ngIf="novaMensagemForm.get('mensagem')?.touched 
        && novaMensagemForm.get('mensagem')?.hasError('required')">
        <small style="color: red;">
          Informe uma mensagem válido.
        </small>
      </div>

    </div>

    <div class="mb-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="removerDosQualificados" formControlName="removerDosQualificados">
        <label class="form-check-label" for="removerDosQualificados">
          Remover Dos Qualificados?
        </label>
      </div>
    </div>

    <div class="mb-3" *ngIf="mostrarCheckboxProjeto">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="projetoFoiCriado" formControlName="projetoFoiCriado">
        <label class="form-check-label" for="projetoFoiCriado">
          Projeto foi criado?
        </label>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-0" id="tour-modal-botoes">
      <button type="submit" class="btn btn-primary" id="tour-modal-salvar">
        Salvar
      </button>
      <button type="button" class="btn btn-outline-primary" (click)="novoProjeto()" id="tour-modal-novo-projeto">
        <i class="fas fa-plus me-2"></i>
        Novo Projeto
      </button>
    </div>
  </form>
</div>